/* =================== BLOCOS HOME =================== */
jQuery(document).ready(function ($) {
  $('a').on('click', function (ev) {
    var $el = $(this);
    var target = $(this).attr('href');
    if (target == 'https://rumoaorlando.kpages.online/wm-mpr') {
      ev.preventDefault();
      setCookie('servico', 'curso', 1);
      window.location.href = url_base + 'servico-temporariamente-indisponivel';
    }
  });
});
